// Redux Form
import { SubmissionError } from 'redux-form';

// Fetch request
import fetch from '../../core/fetch';

// Locale
import messages from '../../locale/jsonMessages';
import showToaster from '../../helpers/toasterMessages/showToaster';

// Redux Action
import { getListingData } from '../../actions/getListing';
import { getListingDataStep2 } from '../../actions/getListingDataStep2';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { getListingFieldsValues } from '../../actions/getListingFieldsValues';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import history from '../../core/history';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';

async function updateStep2(values, dispatch) {

  let dynamicListTitleDescription = values?.dynamicListTitleDescription?.length > 0 ? JSON.stringify(values.dynamicListTitleDescription) : JSON.stringify([]);
  const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: values?.id }));
  if (isRestrict) {
    showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
    return;
  }

  dispatch(setLoaderStart('updateListing'));
  const query = `query (
  	$id: Int,
    $description:String,
    $title:String,
    $coverPhoto: Int
    $dynamicListTitleDescription:String
  ) {
      updateListingStep2 (
        id: $id,
        description:$description,
        title:$title,
        coverPhoto: $coverPhoto
        dynamicListTitleDescription: $dynamicListTitleDescription
      ) {
        status
      }
    }`;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        id: Number(values?.id),
        description: values?.description,
        title: values?.title,
        coverPhoto: values?.coverPhoto,
        dynamicListTitleDescription: dynamicListTitleDescription
      }
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();

  if (data.updateListingStep2.status == "success") {
    await dispatch(manageListingSteps(values.id, 2));
    history.push('/become-a-owner/' + values.id + '/home');
    await dispatch(setLoaderComplete('updateListing'));
    await dispatch(getListingDataStep2(values.id));
    await dispatch(getListingFieldsValues("3", values.id));
  } else if (data.updateListingStep2.status == "notLoggedIn") {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.notLoggedIn });
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default updateStep2;
